import { CheckIcon } from "lucide-react"
import { Separator } from "@/components/ui/separator"
import { cn } from "@/lib/utils"
import { STEPS } from "./helpers"

type StepIndicatorProps = {
  step: number
  showsCoversheetStep: boolean
}

export function StepIndicator({ step, showsCoversheetStep }: StepIndicatorProps) {
  const visibleSteps = showsCoversheetStep ? STEPS : [STEPS[0], STEPS[2]]
  const visibleStepIndex = showsCoversheetStep
    ? step
    : step === 0
      ? 0
      : 1

  return (
    <div className="flex items-center gap-2 pt-2">
      {visibleSteps.map((label, i) => (
        <div key={label} className="flex items-center gap-2 flex-1">
          <div className="flex items-center gap-2 flex-1">
            <div
              className={cn(
                "flex items-center justify-center size-6 rounded-full text-xs font-medium shrink-0 transition-colors",
                visibleStepIndex === i
                  ? "bg-primary text-primary-foreground"
                  : visibleStepIndex > i
                    ? "bg-primary/20 text-primary"
                    : "bg-muted text-muted-foreground"
              )}
            >
              {visibleStepIndex > i ? (
                <CheckIcon className="size-3.5" />
              ) : (
                i + 1
              )}
            </div>
            <span
              className={cn(
                "text-xs font-medium whitespace-nowrap",
                visibleStepIndex === i
                  ? "text-foreground"
                  : "text-muted-foreground"
              )}
            >
              {label}
            </span>
          </div>
          {i < visibleSteps.length - 1 && (
            <Separator className="flex-1 min-w-4" />
          )}
        </div>
      ))}
    </div>
  )
}
